import {
    IFilter,
    BaseFilterValue,
    IFilterHelper,
    FilterAttribute,
    Field,
    getLabel,
    IEntityFilterHelper,
    IActiveFilter
} from "../../entities/Metadata";
import { Dictionary } from "../../entities/common";
import { DisplayFieldService } from "../../components/common/DisplayFieldService";
import { FieldsService } from "../../components/common/FieldsService";
import { ActiveFilter } from "../project/filters";
import { TimeReportingPeriod } from "../TimeReportingPeriodsStore";

type FilterHelperProps = {
    fields: Field[];
};

export class FilterHelper implements IEntityFilterHelper<TimeReportingPeriod> {
    public getFilterAttributes = (fields: Field[]): FilterAttribute<BaseFilterValue>[] => {
        const attrs = fields.map(
            _ =>
                ({
                    type: "attributes",
                    value: _,
                    name: _.name,
                    displayName: getLabel(_)
                }) as FilterAttribute<BaseFilterValue>
        );
        return attrs;
    };

    private attributes: IFilterHelper<BaseFilterValue, TimeReportingPeriod> = {
        buildFilterElement: (
            attr: FilterAttribute<BaseFilterValue>,
            filter: IFilter<BaseFilterValue>,
            onFilterEditComplete: (type: string | number, name: string, value: any) => void
        ): JSX.Element | null => {
            const field: Field = attr.value;
            return DisplayFieldService.buildFieldMultiSelectInput(field, filter.value?.attributes?.[field.name], changed =>
                onFilterEditComplete(attr.type, field.name, changed)
            );
        },
        removeFilterAttribute: (attrName: string, typeValue: any) => {
            const newValue: Dictionary<any> = {};
            Object.keys(typeValue).forEach(vk => {
                if (vk !== attrName) {
                    newValue[vk] = typeValue[vk];
                }
            });
            return newValue;
        },
        setAttributeValue: (attrName: string, value: any, oldValue: any) => {
            if (!oldValue) {
                oldValue = {};
            }
            const tmpValue = { ...oldValue };
            tmpValue[attrName] = value;
            return tmpValue;
        },
        getAttributeValues: (value: any): string[] => FieldsService.getAttributeDisplayValues(this._props.fields, value),
        validateItem: (item: TimeReportingPeriod, filterValue: any, attributes: any[]): boolean => {
            if (!filterValue) {
                return false;
            }
            for (const key in filterValue) {
                if (filterValue.hasOwnProperty(key)) {
                    if (
                        filterValue[key] === undefined ||
                        (Array.isArray(filterValue[key]) && filterValue[key].length === 0)
                    ) {
                        continue;
                    }

                    const attribute = attributes.find(_ => _.name === key);
                    if (!attribute) {
                        return false;
                    }
                    const field = attribute.value;
                    const value = item.attributes[key];

                    if (!FieldsService.compareFieldValues(field, value, filterValue[key])) {
                        return false;
                    }
                }
            }
            return true;
        }
    };

    private readonly _props: FilterHelperProps;
    constructor(props: FilterHelperProps) {
        this._props = props;
    }

    public newFilter = (name: string): IActiveFilter => new ActiveFilter(name);
    public helpersMap: { [K: string]: IFilterHelper<BaseFilterValue, TimeReportingPeriod> } = {
        attributes: this.attributes
    };

    public filter(periods: TimeReportingPeriod[], activeFilter?: IFilter<BaseFilterValue>): TimeReportingPeriod[] {
        if (!activeFilter) {
            return periods;
        }

        const filterValue = activeFilter.value;
        const allAttributes = this.getFilterAttributes(this._props.fields);

        return periods.filter(period => {
            for (const type in filterValue) {
                if (
                    !this.helpersMap[type].validateItem(
                        period,
                        filterValue[type],
                        allAttributes.filter(_ => _.type === type)
                    )
                ) {
                    return false;
                }
            }
            return true;
        });
    }
}
